export interface ColumnInfo {
  title: string;
  iconName: string;
  routerLink?: string;
  href?: string;
  iconNameSecondary?: string;
  iconTitleSecondary?: string;
  value: () => string;
}

export interface DescriptionCardInfo {
  columnFirst: Array<ColumnInfo>;
  columnSecond: Array<ColumnInfo>;
}

export class DescriptionCardImageModel {
  image: string;
  title: string;
}
